import {HttpRequest} from "../../../util/http";
import {IAdmin, IRankingReport} from '../../RankingReportCreationContainer/lib/interfaces';

export const getReports = (reportID: number) => {
  let data = { reportID: reportID };
  const method = 'POST';
  return HttpRequest.fetch('scripts/ranking_reports/report/getReportList', { data, method })
    .then((res: IRankingReport[]) => {
      return res;
    });
}

export const deleteReport = (reportID: number) => {
  let data = { reportID: reportID };
  const method = 'POST';
  return HttpRequest.fetch('scripts/ranking_reports/report/deleteReport', { data, method })
    .then((res: boolean) => {
      return res;
    });
}

export const verifyIfAdmin = (requestedUserId: number) => {
  let data = { requestedUserId: requestedUserId };
  const method = 'POST';
  return HttpRequest.fetch('scripts/users/isAdmin', { data, method })
    .then((res: IAdmin) => {
      return res.isAdmin;
    });
}
